<header class="header-wrapper">

  <!-- ================= TOP HEADER ================= -->
  <div class="top-header" *ngIf="school">
    <div class="container-fluid header-flex">

      <div class="contact-info">
        <strong *ngIf="!isMobile">Get in touch</strong>

        <ng-container *ngIf="school.cnctMobNum">
          <i class="fas fa-phone-alt"></i>
          <span>{{ school.cnctMobNum }}</span>
        </ng-container>

        <span class="divider" *ngIf="school.schAddLine"></span>

        <ng-container *ngIf="school.schAddLine">
          <i class="fas fa-map-marker-alt"></i>
          <span>{{ school.schAddLine }}</span>
        </ng-container>
      </div>

      <div class="codes">
        <span *ngIf="govtCodes.affiliationNo">
          CBSE Affiliation No. {{ govtCodes.affiliationNo }}
        </span>

        <span class="divider" *ngIf="govtCodes.affiliationNo && govtCodes.schoolCode"></span>

        <span *ngIf="govtCodes.schoolCode">
          School Code: {{ govtCodes.schoolCode }}
        </span>
      </div>

    </div>
  </div>

  <!-- ================= NAVBAR ================= -->
  <nav class="main-navbar">
    <div class="nav-inner container-fluid">

      <!-- LOGO -->
      <div class="logo-section" *ngIf="school">
        <a routerLink="/home">
          <img *ngIf="school.schImg.fileUUID"
               [src]="getFilePath(school.schImg.fileUUID)"
               alt="logo" />
        </a>
      </div>

      <!-- MENU -->
      <ul class="nav-menu">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
        </li>

<li class="nav-item dropdown"
    #aboutRla="routerLinkActive"
    routerLinkActive="active">

  <a class="nav-link dropdown-toggle"
     data-bs-toggle="dropdown"
     [class.active]="aboutRla.isActive">
    About
  </a>

  <div class="dropdown-menu">
    <a class="dropdown-item"
       routerLink="/aboutUs"
       routerLinkActive="active">
       About Institution
    </a>

    <a class="dropdown-item"
       routerLink="/directorMsg"
       routerLinkActive="active">
       People Behind the Vision
    </a>
  </div>
</li>

<li class="nav-item dropdown"
    #academicRla="routerLinkActive"
    routerLinkActive="active">

  <a class="nav-link dropdown-toggle"
     data-bs-toggle="dropdown"
     [class.active]="academicRla.isActive">
    Academics
  </a>

  <div class="dropdown-menu">

    <a class="dropdown-item"
       routerLink="/academic"
       routerLinkActive="active">
      Admissions
    </a>

    <a class="dropdown-item"
       routerLink="/curriculum"
       routerLinkActive="active">
      Curriculum CBSE
    </a>

    <a class="dropdown-item"
       routerLink="/guidelines"
       routerLinkActive="active">
      Guidelines
    </a>

  </div>
</li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/gallery" routerLinkActive="active">Gallery</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/news" routerLinkActive="active">News</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/pubDis" routerLinkActive="active">Public Disclosure</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/contact" routerLinkActive="active">Contact</a>
        </li>
      </ul>

      <!-- ACTIONS -->
      <div class="nav-actions">
        <!-- <button class="btn-outline" (click)="openEnquiry()">
          <mat-icon>question_answer</mat-icon>
          Enquiry
        </button> -->

        <button class="btn-solid" (click)="openPayFeesLink()">
          Pay Fees
        </button>
      </div>

      <!-- MOBILE TOGGLE -->
      <div class="mobile-toggle" (click)="toggleMenu()">
        <i class="fas" [ngClass]="isMenuOpen ? 'fa-times' : 'fa-bars'"></i>
      </div>

    </div>

    <!-- MOBILE MENU -->
    <div class="mobile-menu" [class.open]="isMenuOpen">
      <a routerLink="/home">Home</a>
      <a routerLink="/aboutUs">About Institution</a>
      <a routerLink="/directorMsg">Vision</a>

      <a routerLink="/academic">Admissions</a>
      <a routerLink="/curriculum">Curriculum</a>
      <a routerLink="/guidelines">Guidelines</a>

      <a routerLink="/gallery">Gallery</a>
      <a routerLink="/news">News</a>
      <a routerLink="/pubDis">Public Disclosure</a>
      <a routerLink="/contact">Contact</a>

      <!-- <button class="btn-outline w-100 mt-2">Enquiry</button> -->
      <button class="btn-solid w-100 mt-2" (click)="openPayFeesLink()">Pay Fees</button>
    </div>

  </nav>
</header>